"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Copyright_1 = __importDefault(require("../../Copyright"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NotFoundFooter = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.error_page_footer },
        react_1.default.createElement("div", { className: "footer-bottom" },
            react_1.default.createElement("div", { className: "center-copy" },
                react_1.default.createElement(Copyright_1.default, null)))));
};
exports.default = NotFoundFooter;
